export default "__VITE_ASSET__796c7a66__"